import { Link } from "react-router-dom";
import "./styles.css";
// import manufacturingResume from "../../assets/resumes/ManufacturingResume2025.pdf";
// import softwareResume from "../../assets/resumes/SoftwareResume2025.pdf";

function Resume() {
  return (
    <div className="resumeContainer">
      <h1>CHOOSE A RESUME</h1>
      <div className="chooseResume">
        <Link to="manufacturing-resume" className="resumeButton">
          <h2>manufacturing</h2>
        </Link>
        <span></span>
        <Link to="software-resume" className="resumeButton">
          <h2>software</h2>
        </Link>
      </div>
    </div>
  );
}

export default Resume;
